const getters = {
  pageActive:state => state.webPage.pageActive,
  isShowActive:state => state.webPage.isShowActive
}
export default getters
